<template>
  <div>
    <v-card class="mx-auto" max-width="320">
      <img src="https://cdn.vuetifyjs.com/images/cards/sunshine.jpg" width="100%">
    <!--   <v-img src="https://cdn.vuetifyjs.com/images/cards/sunshine.jpg"></v-img> -->

      <v-card-actions>
        <v-btn
          color="blue-grey"
          class="ma-2 white--text"
          @click="downloadImage"
        >
          حفظ الاهداء
          <v-icon right dark> mdi-download </v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "DedicationComponent",
  //********************** */
  components: {},

  //********************** */
  props: {
    dedicationInfo: Object,
  },

  //********************** */
  data: () => ({
    //1080x1920
  }),

  //********************** */
  computed: {
    ...mapGetters({}),
  },

  //********************** */
  watch: {},

  //********************** */
  methods: {
    downloadImage: function () {},
  },

  //*********************** */
  async mounted() {
    // this.downloadImage();
  },
};
</script>

<style>
</style>